// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  forkId: __t.u64().primaryKey().name("fork_id"),
  groupId: __t.u64().name("group_id"),
  initiator: __t.identity(),
  faction: __t.string(),
  openedAt: __t.timestamp().name("opened_at"),
  closesAt: __t.timestamp().name("closes_at"),
  passed: __t.bool(),
  resolved: __t.bool(),
});
